"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.3542 7.29167C13.5877 7.29167 7.29166 13.5877 7.29166 21.3542C7.29166 29.1207 13.5877 35.4167 21.3542 35.4167C29.1207 35.4167 35.4167 29.1207 35.4167 21.3542C35.4167 13.5877 29.1207 7.29167 21.3542 7.29167ZM4.16666 21.3542C4.16666 11.8618 11.8618 4.16667 21.3542 4.16667C30.8465 4.16667 38.5417 11.8618 38.5417 21.3542C38.5417 25.5378 37.0469 29.3722 34.5624 32.3527L44.334 42.1243C44.9442 42.7345 44.9442 43.7238 44.334 44.334C43.7238 44.9442 42.7345 44.9442 42.1243 44.334L32.3527 34.5624C29.3722 37.0469 25.5377 38.5417 21.3542 38.5417C11.8618 38.5417 4.16666 30.8466 4.16666 21.3542Z",
    fill: fill
  }));
};

exports["default"] = _default;